import { Injectable } from '@angular/core';
import { CommonService } from '@src/app/services/common.service';
import { RequestService } from '@src/app/services/request.service';
import { omitFunc } from '@src/app/shared/pipes/omit.pipe';
import { Transaction } from '@src/app/shared/types/transaction.type';

@Injectable()
export class TransactionService {
    constructor(private requestService: RequestService, private commonService: CommonService) {}

    getTransactionDetail(txn: string, chain: string) {
        return this.requestService.sendRequest<Transaction>({
            method: 'GET',
            url: `/v1/socialscan/transactions/${chain}/${txn}`,
        });
    }

    getTokenTransferListByTxn(txn: string, chain: string) {
        return this.requestService
            .sendRequest<any>({
                method: 'GET',
                url: `/v1/socialscan/transaction/${chain}/${txn}/token_transfers`,
            })
            .then(data => data.data);
    }

    replaceActionTypeStr(txn: Transaction, highlightAddress: string) {
        const fromImg = this.commonService.getAddressIcon(txn.from_address);
        const toImg = this.commonService.getAddressIcon(txn.to_address);

        const addressTxtTplGenerator = (type: 'from' | 'to', txn: Transaction, highlightAddress: string) => {
            const displayAddress = type === 'from' ? txn.from_address : txn.to_address;
            const address = type === 'from' ? txn.from_address : txn.to_address;
            const needHighlight = address?.toLowerCase() === highlightAddress?.toLowerCase();

            if (needHighlight) {
                return `<a style="display:inline-block;vertical-align:middle;max-width:100px;" class="inline-block truncate" href="/address/${address}">
                ${omitFunc(displayAddress, 4, 4)}
                </a>`;
            } else {
                return `<a style="vertical-align:middle;font-size:12px;color:#000;opacity:0.8;max-width:90px;"class="truncate inline-block" href="/address/${address}">
                ${omitFunc(displayAddress, 4, 4)}
                </a>`;
            }
        };

        const fromAddressTpl = `<span></span><img style="border-radius:1000px;width:20px;height:20px;display:inline-block;" src="${fromImg}" />
                                ${addressTxtTplGenerator('from', txn, highlightAddress)}</span>`;
        const toAddressTpl = `<img style="border-radius:1000px;width:20px;height:20px;display:inline-block;" src="${toImg}" />
                                ${addressTxtTplGenerator('to', txn, highlightAddress)}`;

        return txn.action?.action_type?.replace('$$from_address', fromAddressTpl).replace('$$to_address', toAddressTpl);
    }
}
